// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"fd8ad33d","453":"03346f77","480":"21160392","746":"b5533cc8","929":"eb920801","941":"a46b4899","992":"a3eedd0a"}[chunkId] + ".chunk.js";
};